import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isEditingEnabled)?_c(VBtn,{attrs:{"icon":""},on:{"click":_vm.reload}},[_c(VIcon,{class:{ 'rotating': _vm.isLoading }},[_vm._v("mdi-autorenew")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }